import { DataMartCard, type DataMart } from "../DataMartCard";
import styles from "./DataMartGrid.module.css";

type DataMartGridProps = {
  dataMarts: DataMart[];
  onDataMartClick: (dataMart: DataMart) => void;
  loading?: boolean;
};

function SkeletonCard() {
  return (
    <div className={styles.card} aria-hidden="true">
      <div className={styles.skeletonHeader}>
        <div className={styles.skeletonIcon} />
        <div className={styles.skeletonTitle} />
      </div>
      <div className={styles.skeletonText} />
      <div className={styles.skeletonText} />
      <div className={styles.skeletonFooter}>
        <div className={styles.skeletonChip} />
        <div className={styles.skeletonChip} />
      </div>
    </div>
  );
}

function SectionEmptyState({ message }: { message: string }) {
  return (
    <div className={styles.sectionEmpty}>
      <p className={styles.emptyText}>{message}</p>
    </div>
  );
}

export default function DataMartGrid({
  dataMarts,
  onDataMartClick,
  loading = false,
}: DataMartGridProps) {
  if (loading) {
    return (
      <div className={styles.container}>
        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Data Marts</h2>
          <div className={styles.grid}>
            {Array.from({ length: 4 }).map((_, index) => (
              <SkeletonCard key={`skeleton-${index}`} />
            ))}
          </div>
        </section>
      </div>
    );
  }

  if (dataMarts.length === 0) {
    return (
      <div className={styles.container}>
        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Data Marts</h2>
          <SectionEmptyState message="No data marts available" />
        </section>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <section className={styles.section}>
        <h2 className={styles.sectionHeading}>Data Marts</h2>
        <div className={styles.grid}>
          {dataMarts.map(dataMart => (
            <DataMartCard
              key={dataMart.id}
              dataMart={dataMart}
              onClick={() => onDataMartClick(dataMart)}
            />
          ))}
        </div>
      </section>
    </div>
  );
}
